import { DeleteOutlined, SaveOutlined, EditOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, Row, Space, Table, Tabs, Tag } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import Column from 'antd/es/table/Column';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import ModalTextForm from '../../../components/modal/ModalTextForm';
import { arrayCommon, currencyFormat, dateCommon, formatVND, validateMessages } from '../../../helpers/common';
import { ImportFileLPS } from '../../../models/luong/Luong';
import { ContentHeader } from '../../../components';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import { Links } from '../../../helpers/Links';
import { menuHelper } from '../../../helpers/account';
import { importFileLuongKhenThuong, layChiTietKhenThuongNhanSuKhac, layMauLuongKhenThuong, luuKhenThuongNhanSuKhac, xoaLuongKhenThuongNhanSuKhac } from '../../../services/nhansukhac';
import { LuongKhenThuongNhanSuKhacResponse } from '../../../models/nhansukhac/NhanSuKhac';

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      size:landscape;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
    
  }
`;

const ChiTietKhenThuongNhanSuKhac = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.Luong.KhenThuongUngHo,
        Links.Luong.ChiTietKhenThuongUngHo]);
    const [form] = useForm();
    const [idKTUH, setIdKTUH] = useState<number>(0);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const [isDisable, setIsDisable] = useState(false);
    const [isShowError, setIsShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [dsNhanVien, setDsNhanVien] = useState<Array<LuongKhenThuongNhanSuKhacResponse>>([]);
    const [editingNV, setEditingNV] = useState<LuongKhenThuongNhanSuKhacResponse>(new LuongKhenThuongNhanSuKhacResponse);
    const [isEdditing, setIsEdditing] = useState(false);
    const [rowIndex, setRowIndex] = useState(-1);
    const [titleIn, setTitleIn] = useState<String>("");
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [reloadPage, setReloadPage] = useState(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [file, setFile] = useState<any>();
    const [formNV] = Form.useForm();

    const onChangeDanhSachNhanVienTableModal = (data: LuongKhenThuongNhanSuKhacResponse, isChecked: boolean) => {
        var tempData = [...dsNhanVien];
        var isExists = arrayCommon.isExisted(dsNhanVien.map(x => x.idNhanSuKhac), data.idNhanSuKhac);
        if (isChecked && !isExists) {
            tempData.unshift(data);
        }        
        if (!isChecked && isExists) {
            var index = tempData.map(x => x.idNhanSuKhac).indexOf(data.idNhanSuKhac);
            if (index > -1) {
                tempData.splice(index, 1);
            }
        }
        setDsNhanVien(tempData);
    }

    const taiFileMau = async () => {
        try {
            var response = await layMauLuongKhenThuong();
            let link = document.createElement('a');
            link.download = `MauLuongKhenThuongNhanSuKhac.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const onFinish = (values: any) => {
        setIsShowError(false);
        setConfirmModal({
            isShowModal: true,
            title: "Lưu khen thưởng",
            content:
                <>Bạn có muốn <label>Lưu</label> khen thưởng này không?</>,
            onSubmit: eventSaveKTUH
        });
    };

    const onFinishNV = (values: any) => {
        setIsEdditing(false);
        setRowIndex(-1);
        editingNV.mucTien = values.mucTien;
        formNV.setFieldsValue({
            mucTienStr: "0",
            mucTien: 0
        });
    }

    const handleFileChange = (files: any) => {
        try {
            if (files.length > 0) {
                const selectedFile = files[0];
                if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    setFile(selectedFile);
                } else {
                    alert("Vui lòng chọn một file Excel (định dạng .xlsx).");
                }
            }
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }

        setShowModal(true);
    };

    const handleUpload = async () => {
        setShowModal(false);
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            var request: ImportFileLPS = {
                file: file,
            }

            try {
                var response = await importFileLuongKhenThuong(request);
                setDsNhanVien(response);
                toast.success("Import dữ liệu lương khen thưởng thành công");
                setFile(null);
            } catch (error) {
                setShowModal(false);
                setFile(null);
                toast.error("Không thể import file. Vui lòng thử lại sau");
            }
        } else {
            toast.error('Vui lòng chọn một tệp tin để tải lên.');
        }
    };

    const eventSaveKTUH = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values: {
            tenKTUH: string;
            khoaDieuChinh: boolean;
        }) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request = {
                    id: idKTUH,
                    ten: values.tenKTUH,
                    khoaDieuChinh: values.khoaDieuChinh ? 1 : 0,
                    dsNhanVien: dsNhanVien,
                };

                var data = await luuKhenThuongNhanSuKhac(request);
                if (data != null && data > 0) {
                    toast.success("Lưu khen thưởng nhân sự khác thành công");
                    setDsNhanVien([]);
                    setIdKTUH(data);
                    setReloadPage(true);
                    navigate(Links.NhanSuKhac.ChiTietLuongKhenThuong + "?id=" + data);
                }
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const layChiTiet = async (id: number) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var data = await layChiTietKhenThuongNhanSuKhac(id);
            if (data.id > 0) {
                form.setFieldsValue({
                    id: data?.id,
                    tenKTUH: data?.ten,
                    khoaDieuChinh: data?.khoaDieuChinh
                });

                setDsNhanVien(data.dsNhanVien);
                setTrangThai(data.khoaDieuChinh);
                setTitleIn(data.ten);
                setIsDisable(true);
                
            }
            setIsLoading(false);
        } catch (error: any) {
            toast.error("Thông tin khen thưởng không tồn tại!");
            setIsLoading(false);
        }
        dispatch(hideLoadingScreen());
    }

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        formNV.setFieldsValue({
            mucTienStr: format,
            mucTien: parsedValue
        });
    };

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaLuongKhenThuongNhanSuKhac(idKTUH);
            navigate(Links.NhanSuKhac.LuongKhenThuong);
            toast.success("Xóa lương khen thưởng nhân sự khác thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        setIdKTUH(+id);
        if (id > 0) {
            layChiTiet(id);
        }
        else {
            form.setFieldsValue({
                thangNam: dayjs(dateCommon.formatDate(new Date(), "dd/MM/yyyy"), "Tháng MM/YYYY"),
                loaiKTUH: 0,
                loaiUngHo: 0,
                khoaDieuChinh: false,
                soTien: 0,
                soTienStr: "0",
                soNgayCong: 0,
            })
        }

    }, []);

    useEffect(() => {
        if (reloadPage) {
            if (idKTUH > 0) {
                layChiTiet(idKTUH);
            }
            setReloadPage(false);
        }
    }, [reloadPage]);

    var tag = (<Tag color="default"></Tag>);
    switch (trangThai) {
        case 0: tag = (<Tag color="success">Khởi tạo</Tag>); break;
        case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
    }

    return (
        <section>
            {showModalDelete && <ModalTextForm show
                title="Xoá lương khen thưởng"
                handleClose={() => setShowModalDelete(false)}
                handleSave={eventDelete}>
                Xác nhận xóa lương khen thưởng
            </ModalTextForm>}
            <ContentHeader title="Chi tiết khen thưởng" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Form
                            layout="vertical"
                            onFinish={onFinish}
                            validateMessages={validateMessages}
                            form={form}
                        >
                            <Tabs
                                tabBarExtraContent={
                                    <Space style={{ zIndex: 1, right: "25px", top: "120px" }}>                                        
                                        {(idKTUH == 0 || (idKTUH > 0 && trangThai == 0)) && <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SaveOutlined rev="" />}
                                            htmlType="submit"
                                        >
                                            Lưu
                                        </Button>}
                                        {(idKTUH > 0 && trangThai == 0) && <Button
                                            loading={isLoading}
                                            type="primary" danger
                                            icon=<DeleteOutlined rev="" />
                                            onClick={() => { setShowModalDelete(true) }}
                                        >
                                            Xóa
                                        </Button>}
                                    </Space>}
                                defaultActiveKey="1" items={[
                                    {
                                        key: "1",
                                        label: "Tùy chỉnh",
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body">
                                                    <Row gutter={48}>
                                                        <Col span="12">
                                                            <Form.Item
                                                                label="Tên khen thưởng"
                                                                name="tenKTUH"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <Input disabled={isDisable && trangThai == 1} />
                                                            </Form.Item>
                                                        </Col>  
                                                        <Col span="4">
                                                            <Form.Item
                                                                name="khoaDieuChinh"
                                                                label=" "
                                                                valuePropName="checked"
                                                            >
                                                                <Checkbox disabled={isDisable && trangThai == 1}>
                                                                    Khóa điều chỉnh
                                                                </Checkbox>
                                                            </Form.Item>
                                                        </Col>
                                                        {
                                                            idKTUH > 0 && (1 >= trangThai && trangThai >= 0) &&
                                                            <Col span="4">
                                                                <Form.Item label="Trạng thái">
                                                                    <label>{tag}</label>
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </Col>
                                            </Row>
                                    }
                                ]}
                            />
                        </Form>
                    </div>
                </Col>
            </Row>
            {
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Form
                                form={formNV}
                                onFinish={onFinishNV}
                            >
                                <Tabs
                                    tabBarExtraContent=
                                    {(idKTUH == 0 || (idKTUH > 0 && trangThai == 0)) &&
                                        <Space style={{ zIndex: 1, right: "25px", top: "120px" }}>
                                            <Button
                                                onClick={() => setShowModal(true)}
                                                type="primary"
                                                loading={isLoading}
                                                icon={<UploadOutlined rev="" />}>
                                                Import file
                                            </Button>
                                            <Button
                                                className="hrm-btn-success"
                                                onClick={taiFileMau}
                                                loading={isLoading}
                                                icon=<DownloadOutlined rev="" />
                                            >
                                                Tải file mẫu
                                            </Button>                                            
                                        </Space>
                                    }
                                    defaultActiveKey="1" items={[
                                        {
                                            key: '1',
                                            label: 'Danh sách nhân viên',
                                            children:
                                                <Table
                                                    locale={{ emptyText: "Không có dữ liệu" }}
                                                    dataSource={(dsNhanVien || []).map((value: any, index: any) => { const item = { key: index, ...value }; return item; })}
                                                    pagination={false}
                                                    rowKey="id"
                                                    sticky
                                                    bordered
                                                    summary={pageData => {
                                                        var totalMucLuongThucNhan = 0;
                                                        var totalPhuCapChucVu = 0;
                                                        var totalMucTien = 0;

                                                        pageData.forEach(({ mucLuongThucNhan, phuCapChucVu, mucTien }) => {
                                                            totalMucLuongThucNhan += mucLuongThucNhan;
                                                            totalPhuCapChucVu += phuCapChucVu;
                                                            totalMucTien += mucTien;
                                                        });

                                                        return (
                                                            <>
                                                                <Table.Summary.Row>
                                                                    <Table.Summary.Cell key={0} index={0} colSpan={3} align="left"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                                                    <Table.Summary.Cell key={3} index={6} align="right"> <label>{formatVND(totalMucTien) || "-"} </label> </Table.Summary.Cell>
                                                                    {!(isDisable && trangThai == 1) && < Table.Summary.Cell index={7} ><label> </label> </Table.Summary.Cell>}
                                                                </Table.Summary.Row>
                                                            </>
                                                        );
                                                    }}
                                                >
                                                    <Column
                                                        title="STT"
                                                        key="STT"
                                                        align="center"
                                                        width="70px"
                                                        render={(value, record, index) =>
                                                        (
                                                            <>
                                                                {index + 1}
                                                            </>
                                                        )
                                                        }
                                                    />
                                                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                                    <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />                                                    
                                                    <Column className="custom-column" title="Mức tiền"
                                                        key="mucTien"
                                                        render={(value: LuongKhenThuongNhanSuKhacResponse, record, index) => (
                                                            index === rowIndex ?
                                                                <>

                                                                    <Form.Item
                                                                        name="mucTienStr"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                            }
                                                                        ]}
                                                                    >
                                                                        <Input prefix="₫ "
                                                                            onChange={(e) => {
                                                                                handleChangeCurrency(e);
                                                                                value.mucTien = +e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
                                                                                dsNhanVien[index].mucTien = value.mucTien;
                                                                                setDsNhanVien([...dsNhanVien]);
                                                                            }
                                                                            }
                                                                        />
                                                                    </Form.Item>
                                                                    <Form.Item hidden name="mucTien" >
                                                                        <Input />
                                                                    </Form.Item>
                                                                </>
                                                                :
                                                                <>
                                                                    {formatVND(value.mucTien)}
                                                                </>
                                                        )
                                                        }
                                                    />
                                                    {!(isDisable && trangThai == 1) &&
                                                        <Column className="text-center"
                                                            title="Hành động"
                                                            key="action"
                                                            render={(value: LuongKhenThuongNhanSuKhacResponse, record, index) => {
                                                                return (
                                                                    <>
                                                                        <Space>
                                                                            {index === rowIndex && isEdditing ? null
                                                                                :
                                                                                <Button
                                                                                    disabled={idKTUH > 0 && trangThai == 1}
                                                                                    type="primary"
                                                                                    icon=<EditOutlined rev="" />
                                                                                    size={"small"}
                                                                                    onClick={() => {
                                                                                        setIsEdditing(true);
                                                                                        setEditingNV(value);
                                                                                        setRowIndex(index);
                                                                                        formNV.setFieldsValue({
                                                                                            mucTien: value?.mucTien,
                                                                                            mucTienStr: currencyFormat.formatMoney(value?.mucTien?.toString()?.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''))
                                                                                        })
                                                                                    }}>Sửa</Button>
                                                                            }
                                                                            {index === rowIndex && isEdditing && <Button className="btn-success" type="primary" size={"small"} icon=<SaveOutlined rev="" /> htmlType='submit'>Lưu</Button>}
                                                                            <Button type="primary"
                                                                                disabled={(idKTUH > 0) && (trangThai == 1)}
                                                                                icon=<DeleteOutlined rev="" />
                                                                                size={"small"}
                                                                                danger
                                                                                onClick={() => {
                                                                                    onChangeDanhSachNhanVienTableModal(value, false);
                                                                                    setRowIndex(-1);
                                                                                }}>Xóa</Button>
                                                                        </Space>
                                                                    </>
                                                                )
                                                            }}
                                                        />}
                                                </Table>
                                        },
                                    ]}>
                                </Tabs>
                            </Form>
                        </div>
                    </Col>
                </Row>
            }
            <ModalTextForm
                show={showModal}
                title="Chọn file"
                handleClose={() => setShowModal(false)}
                handleSave={handleUpload}
            >
                <Dropzone onDrop={handleFileChange} multiple={false}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div {...getRootProps()}
                            className="hrm-dropzone-uploadfile"
                        >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p>Kéo và thả tệp tin ở đây...</p>
                            ) : file ? (
                                <div>
                                    <p>File đã chọn: {file?.name}</p>
                                    <p>Kích thước: {file?.size} bytes</p>
                                </div>
                            ) : (
                                <p>Kéo và thả hoặc chọn một file Excel ở đây.</p>
                            )}
                        </div>
                    )}
                </Dropzone>
            </ModalTextForm>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
        </section>
    );
};

export default ChiTietKhenThuongNhanSuKhac;
